import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useIsBrowser from 'hooks/useIsBrowser';
import useCuralate from 'hooks/useCuralate';
const CRL8_CONTAINER_ID = 'product';

// sc-* names are Curalate's styled-components ids
const CURALATE_REVAMP_CLASSES = ['[&_[role=heading]]:!mb-2',
// Arrows stay inside the clipping carousel box
'[&_.sc-5ocmh8-0]:!pt-14 [&_.sc-5ocmh8-0]:!h-auto [&_.sc-5ocmh8-0]:!px-0 [&_.sc-5ocmh8-0]:!mx-0', '[&_.a8n3dm-0]:!top-0 [&_.a8n3dm-0]:!left-auto [&_.a8n3dm-0]:!w-9 [&_.a8n3dm-0]:!h-9', '[&_.a8n3dm-0:first-child]:!right-11 [&_.a8n3dm-0:last-child]:!right-0', '[&_.a8n3dm-0_button]:!h-9 [&_.a8n3dm-0_button]:!w-9', '[&_.sc-5ocmh8-1]:!w-full [&_[role=list]]:!w-full', '[&_.crl8-product-carousel-item]:!mx-0 [&_.crl8-product-carousel-item]:!mr-6 [&_.crl8-product-carousel-item:last-child]:!mr-0', '[&_.crl8-product-carousel-item]:!flex-none [&_.crl8-product-carousel-item]:!w-full md:[&_.crl8-product-carousel-item]:!w-[calc((100%_-_1.5rem)_/_2)] lg:[&_.crl8-product-carousel-item]:!w-[calc((100%_-_4.5rem)_/_4)]', '[&_.crl8-product-carousel-item_button]:!w-full [&_.crl8-product-carousel-item_div]:!w-full [&_.crl8-product-carousel-item_picture]:block [&_.crl8-product-carousel-item_img]:!w-full [&_.crl8-product-carousel-item_img]:!h-auto', '[&_.crl8-product-carousel-item_.sc-1obuufs-0]:!hidden'].join(' ');

// Split out of PDPFooter so a layout can place it on its own
const PDPCuralateGallery = t0 => {
  const $ = _c(11);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const {
    data
  } = usePDPBasicDetails();
  const isBrowser = useIsBrowser();
  const {
    createExperience,
    destroyExperience
  } = useCuralate();
  const containerRef = useRef(null);
  const sku = data?.sku;
  let t2;
  let t3;
  if ($[0] !== createExperience || $[1] !== destroyExperience || $[2] !== isBrowser || $[3] !== sku) {
    t2 = () => {
      if (!isBrowser || !sku) {
        return;
      }
      const container = containerRef.current;
      createExperience({
        container
      });
      return () => destroyExperience({
        container
      });
    };
    t3 = [isBrowser, sku, createExperience, destroyExperience];
    $[0] = createExperience;
    $[1] = destroyExperience;
    $[2] = isBrowser;
    $[3] = sku;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (!isBrowser) {
    return null;
  }
  const t4 = `productId:${sku}`;
  let t5;
  if ($[6] !== isLayoutRevamp) {
    t5 = classNames({
      [CURALATE_REVAMP_CLASSES]: isLayoutRevamp
    });
    $[6] = isLayoutRevamp;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div ref={containerRef} data-crl8-container-id={CRL8_CONTAINER_ID} data-crl8-filter={t4} className={t5} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
PDPCuralateGallery.propTypes = {
  isLayoutRevamp: PropTypes.bool
};
export default PDPCuralateGallery;